import React, { Component } from "react";
import { FormGroup, FormControl, ControlLabel, HelpBlock, Modal, Button } from "react-bootstrap";
import SignaturePad from "../../../components/SignaturePad.jsx";
import "./DeliveryProtocolForm.css";

const EXPLANATION_LABEL_PATTERN = /(uzasadnij|opisz gdzie)/i;

const optionRequiresExplanation = (option) => {
    if (!option) {
        return false;
    }
    if (option.requiresExplanation === true) {
        return true;
    }
    return EXPLANATION_LABEL_PATTERN.test(option.label || "");
};

const SATISFACTION_OPTIONS = [
    { value: "TAK_BARDZO", label: "TAK - BARDZO" },
    { value: "TAK_Z_DROBNYMI_UWAGAMI", label: "TAK - Z DROBNYMI UWAGAMI (uzasadnij)", requiresExplanation: true },
    { value: "NIE", label: "NIE (uzasadnij)", requiresExplanation: true }
];

const YES_NO_WITH_REASON_OPTIONS = [
    { value: "TAK", label: "TAK" },
    { value: "NIE", label: "NIE (uzasadnij)", requiresExplanation: true }
];

const YES_NO_NA_REFUSED_OPTIONS = [
    { value: "TAK", label: "TAK" },
    { value: "NIE", label: "NIE" },
    { value: "NIE_DOTYCZY", label: "NIE DOTYCZY" },
    { value: "ODMOWA_KLIENTA", label: "ODMOWA KLIENTA" }
];

const DEFAULT_QUESTIONS_BY_ORDER_TYPE = {
    Basic: [
        {
            id: "q1",
            text: "Czy jesteś zadowolony/a z usługi dostawy?",
            required: true,
            options: SATISFACTION_OPTIONS
        },
        {
            id: "q2",
            text: "Czy dostawa dostarczona została w ustalonym przedziale czasowym?",
            required: true,
            options: YES_NO_WITH_REASON_OPTIONS
        },
        {
            id: "q3",
            text: "Czy dostawa odbyła się:",
            required: true,
            options: [
                { value: "W_PIERWSZYM_ZADASZONYM_MIEJSCU", label: "W pierwszym zadaszonym miejscu" },
                { value: "Z_SAMOCHODU", label: "Z samochodu (uzasadnij)", requiresExplanation: true },
                { value: "DO_WSKAZANEGO_MIEJSCA", label: "Do wskazanego przez klienta miejsca (gdzie?)", requiresExplanation: true }
            ]
        },
        {
            id: "q4",
            text: "Czy ustawiono meble w zadaszonym miejscu?",
            required: true,
            options: YES_NO_WITH_REASON_OPTIONS
        },
        {
            id: "q5",
            text: "Czy okazano stan opakowań?",
            required: true,
            options: YES_NO_WITH_REASON_OPTIONS
        },
        {
            id: "q6",
            text: "W przypadku wykrycia uszkodzenia opakowania:",
            required: true,
            options: [
                { value: "TOWAR_NIEUSZKODZONY", label: "Towar nieuszkodzony" },
                { value: "TOWAR_USZKODZONY", label: "Towar uszkodzony" }
            ]
        }
    ],
    Standard: [
        {
            id: "q1",
            text: "Czy jesteś zadowolony/a z usługi dostawy?",
            required: true,
            options: SATISFACTION_OPTIONS
        },
        {
            id: "q2",
            text: "Czy dostawa dostarczona została w ustalonym przedziale czasowym?",
            required: true,
            options: YES_NO_WITH_REASON_OPTIONS
        },
        {
            id: "q3",
            text: "Czy okazano stan opakowań?",
            required: true,
            options: YES_NO_WITH_REASON_OPTIONS
        },
        {
            id: "q4",
            text: "Czy okazano elementy szklane/granitowe/AGD?",
            required: true,
            options: YES_NO_NA_REFUSED_OPTIONS
        },
        {
            id: "q5",
            text: "Czy ustawiono meble we wskazanym miejscu?",
            required: true,
            options: YES_NO_NA_REFUSED_OPTIONS
        }
    ],
    Premium: [
        {
            id: "q1",
            text: "Czy jesteś zadowolony/a z usługi dostawy?",
            required: true,
            options: SATISFACTION_OPTIONS
        },
        {
            id: "q2",
            text: "Czy dostawa odbyła się w ustalonym przedziale czasowym?",
            required: true,
            options: YES_NO_WITH_REASON_OPTIONS
        },
        {
            id: "q3",
            text: "Czy okazano stan opakowań?",
            required: true,
            options: YES_NO_WITH_REASON_OPTIONS
        },
        {
            id: "q4",
            text: "Czy rozpakowano meble (dotyczy brył w całości i tapicerki)?",
            required: true,
            options: YES_NO_NA_REFUSED_OPTIONS
        },
        {
            id: "q5",
            text: "Czy okazano meble (dotyczy brył w całości i tapicerki, w tym okazanie pojemnika na pościel)?",
            required: true,
            options: YES_NO_NA_REFUSED_OPTIONS
        },
        {
            id: "q6",
            text: "Czy okazano elementy szklane?",
            required: true,
            options: YES_NO_NA_REFUSED_OPTIONS
        },
        {
            id: "q7",
            text: "Czy wykonano drobny montaż?",
            required: true,
            options: YES_NO_NA_REFUSED_OPTIONS
        },
        {
            id: "q8",
            text: "Czy ustawiono meble we wskazanym miejscu?",
            required: true,
            options: YES_NO_NA_REFUSED_OPTIONS
        },
        {
            id: "q9",
            text: "Czy wyniesiono opakowania po meblach",
            required: true,
            options: [
                { value: "TAK", label: "TAK" },
                { value: "NIE", label: "NIE (uzasadnij)", requiresExplanation: true },
                { value: "NIE_DOTYCZY", label: "NIE DOTYCZY" },
                { value: "ODMOWA_KLIENTA", label: "ODMOWA KLIENTA (uzasadnij)", requiresExplanation: true }
            ]
        }
    ]
};

class DeliveryProtocolForm extends Component {
    constructor(props) {
        super(props);

        this.signatureModalPadRef = React.createRef();

        this.state = this.buildInitialState(props);
    }

    componentDidUpdate(prevProps) {
        const previousRecipientName = prevProps.initialData && prevProps.initialData.recipientName ? prevProps.initialData.recipientName : "";
        const currentRecipientName = this.props.initialData && this.props.initialData.recipientName ? this.props.initialData.recipientName : "";
        const previousRecipientPhone = prevProps.initialData && prevProps.initialData.recipientPhone ? prevProps.initialData.recipientPhone : "";
        const currentRecipientPhone = this.props.initialData && this.props.initialData.recipientPhone ? this.props.initialData.recipientPhone : "";

        if (
            prevProps.orderType !== this.props.orderType
            || prevProps.questionsByOrderType !== this.props.questionsByOrderType
            || prevProps.formKey !== this.props.formKey
            || previousRecipientName !== currentRecipientName
            || previousRecipientPhone !== currentRecipientPhone
        ) {
            this.setState(this.buildInitialState(this.props));
        }
    }

    buildInitialState = (sourceProps = this.props) => {
        const initialData = sourceProps.initialData || {};
        return {
            recipientName: initialData.recipientName || "",
            recipientPhone: initialData.recipientPhone || "",
            numberOfPackages: initialData.numberOfPackages === null || initialData.numberOfPackages === undefined ? "" : initialData.numberOfPackages,
            remarks: initialData.remarks || "",
            checklist: this.createChecklistState(sourceProps),
            signatureClientBase64: initialData.signatureClient || "",
            signatureProviderBase64: initialData.signatureProvider || "",
            showSignatureModal: false,
            signatureModalType: null,
            signatureModalPadKey: 0,
            errors: {},
            isSubmitting: false,
            isSuccess: false
        };
    };

    getOrderType = () => {
        return this.props.orderType || "Basic";
    };

    getQuestionSets = () => {
        return this.props.questionsByOrderType || DEFAULT_QUESTIONS_BY_ORDER_TYPE;
    };

    getQuestions = () => {
        const questionSets = this.getQuestionSets();
        const orderType = this.getOrderType();

        if (questionSets[orderType] && Array.isArray(questionSets[orderType])) {
            return questionSets[orderType];
        }
        return questionSets.Basic || [];
    };

    createChecklistState = (sourceProps = this.props) => {
        const questionSets = sourceProps.questionsByOrderType || DEFAULT_QUESTIONS_BY_ORDER_TYPE;
        const orderType = sourceProps.orderType || "Basic";
        const questions = questionSets[orderType] || questionSets.Basic || [];
        const initialChecklist = sourceProps.initialData && sourceProps.initialData.checklist ? sourceProps.initialData.checklist : {};

        return questions.reduce((acc, question) => {
            const initialAnswer = initialChecklist[question.id] || {};
            acc[question.id] = {
                answer: initialAnswer.answer || "",
                explanation: initialAnswer.explanation || ""
            };
            return acc;
        }, {});
    };

    handleRecipientNameChange = (event) => {
        this.setState({ recipientName: event.target.value, isSuccess: false });
    };

    handleRecipientPhoneChange = (event) => {
        this.setState({ recipientPhone: event.target.value, isSuccess: false });
    };

    handleNotesChange = (event) => {
        this.setState({ remarks: event.target.value, isSuccess: false });
    };

    handleNumberOfPackagesChange = (event) => {
        this.setState({ numberOfPackages: event.target.value, isSuccess: false });
    };

    handleChecklistAnswerChange = (questionId, value) => {
        this.setState((prevState) => ({
            checklist: {
                ...prevState.checklist,
                [questionId]: {
                    ...prevState.checklist[questionId],
                    answer: value
                }
            },
            isSuccess: false
        }));
    };

    handleChecklistExplanationChange = (questionId, value) => {
        this.setState((prevState) => ({
            checklist: {
                ...prevState.checklist,
                [questionId]: {
                    ...prevState.checklist[questionId],
                    explanation: value
                }
            },
            isSuccess: false
        }));
    };

    getSelectedOption = (question) => {
        const selectedAnswer = this.state.checklist[question.id] ? this.state.checklist[question.id].answer : "";
        if (!selectedAnswer || !Array.isArray(question.options)) {
            return null;
        }
        return question.options.find((option) => option.value === selectedAnswer) || null;
    };

    openSignatureModal = (signatureType) => {
        this.setState({
            showSignatureModal: true,
            signatureModalType: signatureType,
            signatureModalPadKey: Date.now(),
            isSuccess: false
        });
    };

    clearModalSignature = () => {
        if (this.signatureModalPadRef.current && this.signatureModalPadRef.current.clear) {
            this.signatureModalPadRef.current.clear();
        }
    };

    addModalSignature = () => {
        if (!this.signatureModalPadRef.current || !this.signatureModalPadRef.current.hasSignature) {
            return;
        }
        if (!this.signatureModalPadRef.current.hasSignature()) {
            return;
        }

        const signatureBase64 = this.signatureModalPadRef.current.getSignatureDataUrl
            ? this.signatureModalPadRef.current.getSignatureDataUrl()
            : "";
        if (!signatureBase64) {
            return;
        }

        const isClientSignature = this.state.signatureModalType === "client";
        this.setState((prevState) => ({
            signatureClientBase64: isClientSignature ? signatureBase64 : prevState.signatureClientBase64,
            signatureProviderBase64: !isClientSignature ? signatureBase64 : prevState.signatureProviderBase64,
            showSignatureModal: false,
            signatureModalType: null,
            errors: {
                ...prevState.errors,
                signatureClient: isClientSignature ? null : prevState.errors.signatureClient,
                signatureProvider: !isClientSignature ? null : prevState.errors.signatureProvider
            }
        }));
    };

    validateForm = () => {
        const errors = {};
        const questions = this.getQuestions();
        const phonePattern = /^[+0-9(),\-\s]{7,120}$/;

        if (!this.state.recipientName.trim()) {
            errors.recipientName = "Pole imię i nazwisko jest wymagane.";
        }

        if (!this.state.recipientPhone.trim()) {
            errors.recipientPhone = "Pole numer telefonu jest wymagane.";
        } else if (!phonePattern.test(this.state.recipientPhone.trim())) {
            errors.recipientPhone = "Podaj poprawny numer telefonu.";
        }

        if (this.state.numberOfPackages === "" || this.state.numberOfPackages === null || this.state.numberOfPackages === undefined) {
            errors.numberOfPackages = "Pole ilość paczek jest wymagane.";
        } else {
            const numberOfPackages = Number(this.state.numberOfPackages);
            if (!Number.isInteger(numberOfPackages) || numberOfPackages < 0) {
                errors.numberOfPackages = "Podaj poprawną liczbę paczek.";
            }
        }

        questions.forEach((question) => {
            const questionState = this.state.checklist[question.id] || { answer: "", explanation: "" };
            if (question.required !== false && !questionState.answer) {
                errors[question.id] = "To pole jest wymagane.";
            }

            const selectedOption = question.options ? question.options.find((option) => option.value === questionState.answer) : null;
            if (optionRequiresExplanation(selectedOption) && !questionState.explanation.trim()) {
                errors[`${question.id}_explanation`] = "Uzasadnienie jest wymagane.";
            }
        });

        const hasClientSignature = !!this.state.signatureClientBase64;
        const hasProviderSignature = !!this.state.signatureProviderBase64;

        if (!hasClientSignature) {
            errors.signatureClient = "Podpis zleceniodawcy jest wymagany.";
        }

        if (!hasProviderSignature) {
            errors.signatureProvider = "Podpis zleceniobiorcy jest wymagany.";
        }

        this.setState({ errors });
        return Object.keys(errors).length === 0;
    };

    buildPayload = () => {
        const questions = this.getQuestions();

        const checklistPayload = questions.reduce((acc, question) => {
            const questionState = this.state.checklist[question.id] || { answer: "", explanation: "" };
            acc[question.id] = {
                answer: questionState.answer || null
            };
            if (questionState.explanation && questionState.explanation.trim()) {
                acc[question.id].explanation = questionState.explanation.trim();
            }
            return acc;
        }, {});

        return {
            orderUuid: this.props.orderUuid || null,
            orderType: this.getOrderType(),
            recipientName: this.state.recipientName.trim(),
            recipientPhone: this.state.recipientPhone.trim(),
            numberOfPackages: this.state.numberOfPackages === "" ? null : parseInt(this.state.numberOfPackages, 10),
            remarks: this.state.remarks.trim(),
            checklist: checklistPayload,
            signatureClient: this.state.signatureClientBase64,
            signatureProvider: this.state.signatureProviderBase64
        };
    };

    handleSubmit = async (event) => {
        event.preventDefault();

        if (!this.validateForm()) {
            return;
        }

        const payload = this.buildPayload();
        const onSubmit = this.props.onSubmit;

        if (typeof onSubmit !== "function") {
            this.setState({ isSuccess: true });
            return;
        }

        this.setState({ isSubmitting: true });
        try {
            await onSubmit(payload);
            this.setState({ isSubmitting: false, isSuccess: true });
        } catch (error) {
            this.setState({
                isSubmitting: false,
                isSuccess: false,
                errors: {
                    submit: "Nie udało się zapisać formularza. Spróbuj ponownie."
                }
            });
        }
    };

    render() {
        const questions = this.getQuestions();
        const { errors, isSubmitting, isSuccess } = this.state;
        const hasClientSignature = !!this.state.signatureClientBase64;
        const hasProviderSignature = !!this.state.signatureProviderBase64;
        const isClientModal = this.state.signatureModalType === "client";
        const signatureModalTitle = isClientModal ? "Podpis klienta" : "Podpis dostawcy";

        return (
            <>
                <form className="delivery-protocol-form" onSubmit={this.handleSubmit}>
                    <h3 className="delivery-protocol-form__title">Elektroniczny protokół dostawy</h3>
                    <p className="delivery-protocol-form__subtitle">
                        Typ zlecenia: <strong>{this.getOrderType()}</strong>
                    </p>

                    <FormGroup validationState={errors.recipientName ? "error" : null}>
                        <ControlLabel>Imię i nazwisko odbiorcy</ControlLabel>
                        <FormControl
                            type="text"
                            value={this.state.recipientName}
                            onChange={this.handleRecipientNameChange}
                            placeholder="Wpisz imię i nazwisko"
                        />
                        {errors.recipientName ? <HelpBlock>{errors.recipientName}</HelpBlock> : null}
                    </FormGroup>

                    <FormGroup validationState={errors.recipientPhone ? "error" : null}>
                        <ControlLabel>Numer telefonu odbiorcy</ControlLabel>
                        <FormControl
                            type="text"
                            value={this.state.recipientPhone}
                            onChange={this.handleRecipientPhoneChange}
                            placeholder="Wpisz numer telefonu"
                        />
                        {errors.recipientPhone ? <HelpBlock>{errors.recipientPhone}</HelpBlock> : null}
                    </FormGroup>

                    <FormGroup validationState={errors.numberOfPackages ? "error" : null}>
                        <ControlLabel>Ilość paczek</ControlLabel>
                        <FormControl
                            type="number"
                            min={0}
                            step={1}
                            value={this.state.numberOfPackages}
                            onChange={this.handleNumberOfPackagesChange}
                            placeholder="Podaj ilość paczek"
                        />
                        {errors.numberOfPackages ? <HelpBlock>{errors.numberOfPackages}</HelpBlock> : null}
                    </FormGroup>

                    <div className="delivery-protocol-form__section">
                        <h4 className="delivery-protocol-form__section-title">Checklista</h4>
                        {questions.map((question) => (
                            <div className="delivery-protocol-form__question" key={question.id}>
                                <p className="delivery-protocol-form__question-title">{question.text}</p>
                                <div className="delivery-protocol-form__options">
                                    {(question.options || []).map((option) => (
                                        <label key={`${question.id}_${option.value}`} className="delivery-protocol-form__option">
                                            <input
                                                type="radio"
                                                name={question.id}
                                                value={option.value}
                                                checked={(this.state.checklist[question.id] ? this.state.checklist[question.id].answer : "") === option.value}
                                                onChange={(event) => this.handleChecklistAnswerChange(question.id, event.target.value)}
                                            />
                                            <span>{option.label}</span>
                                        </label>
                                    ))}
                                </div>
                                {errors[question.id] ? <p className="delivery-protocol-form__error">{errors[question.id]}</p> : null}

                                {(() => {
                                    const selectedOption = this.getSelectedOption(question);
                                    if (!optionRequiresExplanation(selectedOption)) {
                                        return null;
                                    }

                                    return (
                                        <div className="delivery-protocol-form__explanation">
                                            <FormControl
                                                componentClass="textarea"
                                                rows={2}
                                                value={this.state.checklist[question.id] ? this.state.checklist[question.id].explanation : ""}
                                                onChange={(event) => this.handleChecklistExplanationChange(question.id, event.target.value)}
                                                placeholder="Wpisz uzasadnienie"
                                            />
                                            {errors[`${question.id}_explanation`] ? (
                                                <p className="delivery-protocol-form__error">{errors[`${question.id}_explanation`]}</p>
                                            ) : null}
                                        </div>
                                    );
                                })()}
                            </div>
                        ))}
                    </div>

                    <FormGroup>
                        <ControlLabel>Uwagi</ControlLabel>
                        <FormControl
                            componentClass="textarea"
                            rows={4}
                            value={this.state.remarks}
                            onChange={this.handleNotesChange}
                            placeholder="Dodatkowe informacje"
                        />
                    </FormGroup>

                    <div className="delivery-protocol-form__section">
                        <h4 className="delivery-protocol-form__section-title">Podpis zleceniodawcy</h4>
                        <Button
                            type="button"
                            className="btn-fill btn-block"
                            onClick={() => this.openSignatureModal("client")}
                        >
                            {hasClientSignature ? "Edytuj podpis klienta" : "Dodaj podpis klienta"}
                        </Button>
                        {errors.signatureClient ? <p className="delivery-protocol-form__error">{errors.signatureClient}</p> : null}
                    </div>

                    <div className="delivery-protocol-form__section">
                        <h4 className="delivery-protocol-form__section-title">Podpis zleceniobiorcy</h4>
                        <Button
                            type="button"
                            className="btn-fill btn-block"
                            onClick={() => this.openSignatureModal("provider")}
                        >
                            {hasProviderSignature ? "Edytuj podpis dostawcy" : "Dodaj podpis dostawcy"}
                        </Button>
                        {errors.signatureProvider ? <p className="delivery-protocol-form__error">{errors.signatureProvider}</p> : null}
                    </div>

                    {errors.submit ? <p className="delivery-protocol-form__error">{errors.submit}</p> : null}
                    {isSuccess ? <p className="delivery-protocol-form__success">Formularz został zapisany.</p> : null}

                    <div className="delivery-protocol-form__actions">
                        <button
                            type="submit"
                            className="btn btn-success btn-fill btn-lg"
                            disabled={isSubmitting}
                        >
                            {isSubmitting ? "Zapisywanie..." : "Zapisz formularz"}
                        </button>
                    </div>
                </form>

                <Modal
                    show={this.state.showSignatureModal}
                    backdrop="static"
                    keyboard={false}
                    onHide={() => {}}
                    style={{ paddingLeft: 0 }}
                >
                    <Modal.Header>
                        {signatureModalTitle}
                    </Modal.Header>
                    <Modal.Body>
                        <SignaturePad
                            key={this.state.signatureModalPadKey}
                            ref={this.signatureModalPadRef}
                            width={300}
                            height={120}
                            showActions={false}
                        />
                    </Modal.Body>
                    <Modal.Footer>
                        <Button bsStyle="default" onClick={this.clearModalSignature}>Wyczyść</Button>
                        <Button bsStyle="primary" onClick={this.addModalSignature}>Dodaj</Button>
                    </Modal.Footer>
                </Modal>
            </>
        );
    }
}

export default DeliveryProtocolForm;
